import React from 'react';
import Mousetrap from 'mousetrap';
import Select from 'react-select';
import { withRouter } from 'react-router';
import { Query } from 'react-apollo';
import { ALL_FUNDS } from '../../graphql/queries/all-funds.query';
import ErrorBoundary from '../ErrorBoundary/ErrorBoundary';
import Popup from '../Popup/Popup';
import { quickSearchHandleChange } from '../../utils/navigation';
import { filterFundsByTicker, isBuyRestricted } from '../../utils/fund-info';
import styles from './QuickSearch.css';
import { publicOfferingFilterUtil } from '../../utils/GqlDataUtil/GqlDataUtil';
import { ETF_ASSET_CLASS_TYPES } from '../../utils/constants';

const isMobile = window.innerWidth < 768;

const popUpStyle = {
    width: isMobile ? '90%' : '50%',
    borderRadius: '10px',
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.5)'
};

export const stitchResults = (
    { allExchangeTradedFunds, allMutualFunds },
    hideNonComparable
) => {
    let filteredETFs;
    filteredETFs = publicOfferingFilterUtil(allExchangeTradedFunds);
    if (hideNonComparable) {
        filteredETFs = filteredETFs.filter(
            (etf) => etf.assetClassName !== ETF_ASSET_CLASS_TYPES.DIGITAL_ASSETS
        );
    }

    const filteredMFs = allMutualFunds.filter(
        (fund) =>
            !isBuyRestricted(
                fund.openToNewInvestors,
                fund.openToSubsequentInvestments
            )
    );

    return [
        ...filteredETFs.map((f) => ({ ...f, etf: true })),
        ...filterFundsByTicker(filteredMFs)
    ].sort((a, b) => {
        if (a.label > b.label) {
            return 1;
        }
        if (a.label < b.label) {
            return -1;
        }
        return 0;
    });
};

class QuickSearch extends React.Component {
    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount() {
        Mousetrap.bind(['shift+1'], (e) => {
            e.preventDefault();
            return this.props.toggle();
        });
    }

    render() {
        const {
            open,
            closeModal,
            handleChange,
            hideNonComparable
        } = this.props;
        const handleSelection = handleChange || quickSearchHandleChange;
        return (
            <React.Fragment>
                <Popup
                    open={open}
                    closeOnDocumentClick
                    closeOnEscape
                    onClose={closeModal}
                    contentStyle={popUpStyle}
                >
                    <div className="modal">
                        <div className="search-title">
                            Search by fund name or ticker:
                        </div>
                        <ErrorBoundary errorMsg="uh oh">
                            <Query query={ALL_FUNDS}>
                                {({ data }) =>
                                    Boolean(
                                        data &&
                                            (data.allMutualFunds ||
                                                data.allExchangeTradedFunds)
                                    ) && (
                                        <Select
                                            styles={{
                                                option: (
                                                    provided,
                                                    { data: { etf } }
                                                ) => ({
                                                    ...provided,
                                                    borderLeft: `6px solid ${
                                                        etf
                                                            ? // colored border for QuickSearch dropdown items
                                                              // can't share a variable with the Compare header since
                                                              // one needs it React side and this needs it static/public side
                                                              '#ffc42d'
                                                            : '#05C3DE'
                                                    }`,
                                                    borderBottom:
                                                        '2px solid white'
                                                })
                                            }}
                                            onChange={(e) => handleSelection(e)}
                                            options={stitchResults(
                                                data,
                                                hideNonComparable
                                            )}
                                            autoFocus
                                        />
                                    )
                                }
                            </Query>
                        </ErrorBoundary>
                    </div>
                </Popup>
                <style jsx>{styles}</style>
            </React.Fragment>
        );
    }
}

export default withRouter(QuickSearch);
